module.exports = __webpack_public_path__ + "fonts/5d32a5d1/aboutme-glyphs.woff";